import { apiClient } from 'client/core/network/apiClient';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import { IRequestAttachment } from 'common/schema/request/RequestAttachment';

// Allegati
export const RequestAttachmentApi = {
  upload: (opts: { data: FormData }) =>
    apiClient.post<IRequestAttachment>(`/request-attachments`, opts.data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  remove: (opts: { id: string; query: any }) =>
    apiClient.delete<any>(`/request-attachments/${opts.id}`, {
      params: opts.query
    })
};
